import $ from 'jquery';
import { helpers } from '@bingads-webui/projection-grid-toolbar';
import { GENERAL_INSIGHTS_DATA_TYPES } from '@bingads-webui-campaign-react/competition-core';

import { getDataSource } from './general-insights-data-source';
import { getPluginsConfig } from './general-insights-plugin-config';
import { getColumnsConfig } from './general-insights-grid-columns';

const { toolbarRow } = helpers;

export function getConfig({
  view,
  scope,
  addDateChangeListener,
  container,
  filterService,
  currentScenario,
  currentActivity,
  toggleChartToolbar,
  campaignType,
  onCampaignTypeSelectChange,
  showCampaignTypeDropdown,
  featureName,
  showAlertHandler,
}) {
  const dataSource = getDataSource(GENERAL_INSIGHTS_DATA_TYPES.Grid);

  return {
    name: featureName,
    tableClasses: ['table', 'table-bordered'],
    isDataFetchManagerSource: true,
    dataSource,
    filterService,
    rows: {
      headRows: [
        toolbarRow('lower-toolbar'),
        'column-header-rows',
      ],
      bodyRows: [
        {
          type: 'data-rows',
          classes: {
            'auction-insight-column-you': ({ DisplayDomain }) => DisplayDomain === 'You',
          },
        },
      ],
    },
    columns: getColumnsConfig({
      scope,
      campaignType,
    }),
    scrolling: {
      header: {
        type: 'sticky',
        offset() {
          return $('nav.navbar-default.navbar-fixed-top').height();
        },
      },
      virtualized: true,
    },
    plugins: getPluginsConfig({
      view,
      scope,
      addDateChangeListener,
      container,
      toggleChartToolbar,
      campaignType,
      onCampaignTypeSelectChange,
      showCampaignTypeDropdown,
      showAlertHandler,
    }),
    currentScenario,
    currentActivity,
  };
}
